import roller from 'common/module/ui/roller';

import applicationBootstrap from 'website/bootstrap';
import asyncGallery from 'website/module/ui/async-gallery';
import castFetch from 'website/module/ui/cast-fetch';
import dropdownLinks from 'website/module/ui/dropdown-custom';
import shotsFetch from 'website/module/ui/shots-fetch';
import thirdNav from 'website/module/ui/third-nav';

// bootstrap the application / store
applicationBootstrap().then(() => {
  thirdNav();

  dropdownLinks();

  roller();

  asyncGallery();

  shotsFetch();

  castFetch();
});
